
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thread-finder/[twUserName]/[id]",
      function () {
        return require("private-next-pages/thread-finder/[twUserName]/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thread-finder/[twUserName]/[id]"])
      });
    }
  